import React, { useEffect, useState } from 'react';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

// Função utilitária para chamadas da API com fallback
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const urls = [
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`
  ];

  for (const url of urls) {
    try {
      console.log(`Tentando ${method} em: ${url}`);
      const config = {
        method,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      const token = getAuthToken();
      if (token) config.headers['Authorization'] = 'Bearer ' + token;
      
      if (data && (method === 'POST' || method === 'PUT')) {
        config.body = JSON.stringify(data);
      }

      const response = await fetch(url, config);
      
      if (response.ok) {
        console.log(`✅ Sucesso em: ${url}`);
        if (method === 'DELETE' || response.status === 204) {
          return { success: true };
        }
        return await response.json();
      }
      console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
    } catch (error) {
      console.log(`❌ Erro em: ${url} - ${error.message}`);
    }
  }
  
  throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
};

function FormularioOportunidade({ 
  clienteId, 
  dadosOportunidade, 
  setDadosOportunidade, 
  modoEdicao = false, 
  onSalvar,
  onClose 
}) {
  const [form, setForm] = useState({
    id: '',
    clienteId: clienteId || '',
    titulo: '',
    descricao: '',
    status: 'Em Prospecção',
    dataCriacao: new Date().toISOString().split('T')[0]
  });

  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mostrarSucesso, setMostrarSucesso] = useState(false);
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);

  // Lista de status disponíveis
  const statusDisponiveis = [
    'Em Prospecção',
    'Qualificada',
    'Proposta Enviada',
    'Em Negociação',
    'Fechada - Ganha',
    'Fechada - Perdida',
    'Cancelada'
  ];

  // Carregar dados do cliente
  useEffect(() => {
    const carregarCliente = async () => {
      if (!clienteId) return;
      
      try {
        console.log(`Carregando dados do cliente ID: ${clienteId}`);
        const clienteData = await apiCall(`Cliente/${clienteId}`);
        setCliente(clienteData);
      } catch (error) {
        console.error('Erro ao carregar cliente:', error);
        setError(`Erro ao carregar dados do cliente: ${error.message}`);
      }
    };

    carregarCliente();
  }, [clienteId]);

  // Carregar dados da oportunidade se for edição
  useEffect(() => {
    if (modoEdicao && dadosOportunidade) {
      setForm({
        id: dadosOportunidade.id || '',
        clienteId: dadosOportunidade.clienteId || clienteId || '',
        titulo: dadosOportunidade.oportunidade_Titulo || dadosOportunidade.titulo || '',
        descricao: dadosOportunidade.descricao || '',
        status: dadosOportunidade.status || 'Em Prospecção',
        dataCriacao: dadosOportunidade.dataCriacao || new Date().toISOString().split('T')[0]
      });
    } else {
      // Modo criação - apenas garantir que clienteId está setado
      setForm(prev => ({
        ...prev,
        clienteId: clienteId || prev.clienteId
      }));
    }
  }, [modoEdicao, dadosOportunidade, clienteId]);

  // Função para atualizar campos do form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // Função de submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Verificar se o botão está desabilitado
    if (botaoDesabilitado) {
      return;
    }
    
    setLoading(true);
    setError('');

    // Validações
    if (!form.clienteId) {
      setError('Cliente é obrigatório.');
      setLoading(false);
      return;
    }

    if (!form.titulo.trim()) {
      setError('Título é obrigatório.');
      setLoading(false);
      return;
    }

    if (!form.descricao.trim()) {
      setError('Descrição é obrigatória.');
      setLoading(false);
      return;
    }

    // Preparar payload com campos exatos do backend
    const oportunidadePayload = {
      clienteId: parseInt(form.clienteId),
      titulo: form.titulo.trim(),
      descricao: form.descricao.trim(),
      status: form.status || 'Em Prospecção',
      dataCriacao: form.dataCriacao || new Date().toISOString().split('T')[0]
    };

    try {
      let resultado;
      
      console.log('=== DEBUG OPORTUNIDADE PAYLOAD ===');
      console.log('Payload que será enviado:', oportunidadePayload);
      console.log('Modo:', modoEdicao ? 'Edição (PUT)' : 'Criação (POST)');

      if (modoEdicao && form.id) {
        // Modo edição: PUT
        resultado = await apiCall(`Oportunidade/${form.id}`, 'PUT', {
          ...oportunidadePayload,
          id: parseInt(form.id)
        });
      } else {
        // Modo criação: POST
        console.log('Fazendo POST para: Oportunidade');
        resultado = await apiCall('Oportunidade', 'POST', oportunidadePayload);
      }

      console.log('✅ Oportunidade salva com sucesso:', resultado);
      
      // ✅ SUCESSO - Para criar nova oportunidade
      if (!modoEdicao) {
        console.log('✅ Oportunidade criada com sucesso!');
        
        // Mostrar notificação de sucesso
        setMostrarSucesso(true);
        
        // Fechar popup após 2 segundos
        setTimeout(() => {
          setMostrarSucesso(false);
          // Callback para atualizar dados na tela pai
          if (onSalvar) {
            onSalvar(resultado);
          }
          // Fechar formulário
          if (onClose) {
            onClose();
          }
        }, 2000);
      } else {
        // Para edição, apenas fechar
        console.log('✅ Oportunidade editada com sucesso!');
        // Callback para atualizar dados na tela pai
        if (onSalvar) {
          onSalvar(resultado);
        }
        // Fechar formulário
        if (onClose) {
          onClose();
        }
      }

    } catch (error) {
      console.error('❌ Erro ao salvar oportunidade:', error);
      setError(`Erro ao salvar oportunidade: ${error.message}`);
      alert(`Erro ao salvar oportunidade: ${error.message}`);
      
      // ❌ ERRO - Desabilitar botão por 5 segundos
      setBotaoDesabilitado(true);
      setTimeout(() => {
        setBotaoDesabilitado(false);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '700px',
        height: 'auto',
        margin: '8px auto 20px auto',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        fontFamily: 'Arial, sans-serif',
        position: 'relative',
        boxSizing: 'border-box'
      }}
    >
      <h2 style={{ 
        color: 'rgb(235, 133, 0)', 
        marginBottom: '15px', 
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 'bold'
      }}>
        {modoEdicao ? 'Editar Oportunidade' : 'Nova Oportunidade'}
      </h2>

      {/* Informações do Cliente */}
      {cliente && (
        <div style={{
          backgroundColor: '#f5f5f5',
          padding: '10px',
          borderRadius: '6px',
          marginBottom: '15px',
          border: '1px solid #ddd',
          fontSize: '12px'
        }}>
          <h3 style={{ color: 'rgb(235, 133, 0)', marginBottom: '8px', fontSize: '14px' }}>
            Cliente Selecionado
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '12px' }}>
            <div><strong>Nome:</strong> {cliente.nome}</div>
            <div><strong>Email:</strong> {cliente.email}</div>
            <div><strong>Telefone:</strong> {cliente.celular}</div>
            <div><strong>Endereço:</strong> {cliente.endereco}</div>
          </div>
        </div>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '15px'
      }}>
        {/* Campo Cliente ID (readonly) */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            ID do Cliente
          </label>
          <input
            type="number"
            name="clienteId"
            value={form.clienteId}
            readOnly
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '100%',
              backgroundColor: '#f5f5f5',
              cursor: 'not-allowed',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Campo Status */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Status
          </label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '100%',
              boxSizing: 'border-box'
            }}
          >
            {statusDisponiveis.map(status => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        {/* Campo Título */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Título da Oportunidade *
          </label>
          <input
            type="text"
            name="titulo"
            value={form.titulo}
            onChange={handleChange}
            placeholder="Digite o título da oportunidade"
            required
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Campo Descrição */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Descrição *
          </label>
          <textarea
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
            placeholder="Descreva detalhadamente a oportunidade"
            required
            rows="3"
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '100%',
              maxWidth: '100%',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Campo Data de Criação */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Data de Criação
          </label>
          <input
            type="date"
            name="dataCriacao"
            value={form.dataCriacao}
            onChange={handleChange}
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '100%',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>

      {/* Exibir erros */}
      {error && (
        <div style={{ 
          marginTop: '15px', 
          padding: '8px', 
          backgroundColor: '#ffe6e6', 
          border: '1px solid #ff9999', 
          borderRadius: '5px',
          color: '#cc0000',
          fontSize: '13px'
        }}>
          {error}
        </div>
      )}

      {/* Botões */}
      <div className="oportunidade-form-botoes">
        <button
          type="submit"
          className="oportunidade-form-btn-salvar"
          disabled={loading || botaoDesabilitado}
          style={{
            backgroundColor: (loading || botaoDesabilitado) ? '#ccc' : 'rgb(235, 133, 0)',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            fontSize: '14px',
            cursor: (loading || botaoDesabilitado) ? 'not-allowed' : 'pointer',
            marginRight: '10px',
            transition: 'background-color 0.3s ease',
            opacity: botaoDesabilitado ? 0.7 : 1
          }}
          onMouseEnter={(e) => {
            if (!loading && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(250, 178, 65)';
          }}
          onMouseLeave={(e) => {
            if (!loading && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(235, 133, 0)';
          }}
        >
          {botaoDesabilitado ? 'Aguarde 5 segundos...' : (loading ? 'Salvando...' : (modoEdicao ? 'Atualizar' : 'Salvar'))} {!botaoDesabilitado && 'Oportunidade'}
        </button>
        
        <button
          type="button"
          className="oportunidade-form-btn-cancelar"
          onClick={onClose}
          style={{
            backgroundColor: '#666',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#888'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#666'}
        >
          Cancelar
        </button>
      </div>
      
      {/* Notificação de sucesso */}
      {mostrarSucesso && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          color: 'rgb(235, 133, 0)',
          padding: '15px 30px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          fontSize: '16px',
          fontWeight: '600',
          zIndex: 9999,
          animation: 'fadeInOut 2.5s ease-in-out forwards',
          border: '2px solid rgb(235, 133, 0)'
        }}>
          Oportunidade adicionada com sucesso!
        </div>
      )}

      <style jsx>{`
        @keyframes fadeInOut {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          15% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px);
          }
          85% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
        }
      `}</style>
    </form>
  );
}

export default FormularioOportunidade;
